<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
      >
        <!--        <el-tab-pane :label="$t('CargoMsg.Cargo_BranchBill')" name="branchBill">-->
        <!--          <bill-overseas-s-center-view />-->
        <!--        </el-tab-pane>-->
        <!--        <el-tab-pane :label="$t('CargoMsg.Cargo_Submitted')" name="submitted">-->
        <!--          <bill-overseas-s-submit-view />-->
        <!--        </el-tab-pane>-->
        <!--        <el-tab-pane v-if="$checkPermission(['tab_BillOverseasSCenter_billOverseasAccept'])" :label="$t('CargoMsg.Cargo_Received')" name="received">-->
        <!--          <bill-overseas-s-accept-view />-->
        <!--        </el-tab-pane>-->
        <!--        <el-tab-pane v-if="$checkPermission(['tab_BillOverseasSCenter_billOverseasMsg'])" :label="$t('CargoMsg.Cargo_SettlementNotice')" name="settlementNotice">-->
        <!--          <bill-actual-amount />-->
        <!--        </el-tab-pane>-->
        <el-tab-pane :label="$t('CargoMsg.Cargo_BranchBill')" name="branchBill">
          <new-bill-overseas-s-center-view />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_Submitted')" name="submitted">
          <new-bill-overseas-s-submit-view />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_BillOverseasSCenter_billOverseasAccept'])" :label="$t('CargoMsg.Cargo_Received')" name="received">
          <new-bill-overseas-s-accept-view />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_BillOverseasSCenter_billOverseasMsg'])" :label="$t('CargoMsg.Cargo_SettlementNotice')" name="settlementNotice">
          <new-bill-actual-amount />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_BillOverseasSCenter_billOverseasConfirm'])" :label="$t('CargoMsg.Cargo_BranchConfirmation')" name="branchConfirmation">
          <office-confirm-new />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import BillOverseasSCenterView from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/billOverseasSCenterView'
import BillOverseasSSubmitView from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/billOverseasSSubmitView'
import BillOverseasSAcceptView from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/billOverseasSAcceptView'
import BillActualAmount from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/billActualAmount'
import OfficeConfirmNew from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/officeConfirmNew'
import NewBillOverseasSCenterView from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/newBillOverseasSCenterView'
import NewBillOverseasSSubmitView from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/newBillOverseasSSubmitView'
import NewBillOverseasSAcceptView from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/newBillOverseasSAcceptView'
import NewBillActualAmount from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/newBillActualAmount'
export default {
  name: 'BillOverseasSCenter',
  components: {
    OfficeConfirmNew,
    BillActualAmount, BillOverseasSAcceptView, BillOverseasSSubmitView, BillOverseasSCenterView,
    NewBillActualAmount, NewBillOverseasSAcceptView, NewBillOverseasSSubmitView, NewBillOverseasSCenterView
  },
  data() {
    return {
      activeTabName: 'branchBill'
    }
  }
}
</script>

<style scoped>

</style>
